import { Box, IconButton, Typography } from '@mui/material';
import { addMonths, subMonths } from 'date-fns';
import { useIntl } from 'react-intl';

import { SlotProps } from './types';

import * as S from './styles';

export function CalendarHeader({ currentMonth, onMonthChange }: SlotProps) {
  const intl = useIntl();
  const selectNextMonth = () =>
    onMonthChange(addMonths(currentMonth, 1), 'left');

  const selectPreviousMonth = () =>
    onMonthChange(subMonths(currentMonth, 1), 'right');

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={3}
    >
      <Typography variant="h6">
        {intl.formatMessage({ id: 'CAREMATRIXCPTC.MOODTRACKERTITLE.NAME' })}
      </Typography>

      <Box display="flex" alignItems="center" gap={1}>
        <IconButton onClick={selectPreviousMonth}>
          <S.BackArrow />
        </IconButton>

        <S.Month variant="body2">
          {currentMonth
            .toLocaleDateString(intl.locale, {
              month: 'short',
            })
            // @ts-expect-error -- it's requiring to target a higher version of ECMAScript. As this problem is just related to typescript and it works at runtime, we can ignore it for now.
            // this replace exists because in pt-BR it returns `mai.` and we are removing the dot
            .replace(/[^\p{L}\p{N}]/gu, '')}{' '}
          {currentMonth.toLocaleDateString(intl.locale, {
            year: 'numeric',
          })}
        </S.Month>

        <IconButton onClick={selectNextMonth}>
          <S.ForwardArrow />
        </IconButton>
      </Box>
    </Box>
  );
}
